import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "rmaNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.RMA.fullString,
    hasInputLabel: true,
  },
  { apiName: "rmaFooter", component: "FrmResizeTextField" },
  { apiName: "replyEmailRMA", component: "FrmEmail", maxLength: 255 },
  { apiName: "rmaEmailText", component: "FrmResizeTextField" },
];
